// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"641335de1fb606eb7b97","883":"4fb41b8a8c3e4f90e812"}[chunkId] + ".js";
};